import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Gridster, GridsterItem } from 'angular-gridster2';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ClickOutsideModule } from 'ng-click-outside';

import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { LayoutModule } from '../Layout/layout.module';
import { MiscModule } from '../Misc/misc.module';
import { PageBuilderModule } from '../PageBuilder/page-builder.module';
import { CommonBasicModule } from '../Basic/basic.module';
import { ReportsModule } from '../Reports/reports.module';
import { FilterModule } from '../Filter/filter.module';
import { ChartsModule } from '../Charts/charts.module';
import { CommonDialogsModule } from '../Dialogs/common-dialogs.module';
import { TakeOverModule } from '../TakeOver/take-over.module';
import { MonitorSharedModule } from '@Monitor/Shared/monitoring-shared.module';

import { DashboardApi } from '../../api/dashboard/dashboard.api';

import { DashboardService } from './services/dashboard.service';
import { DashboardPageBuilderService } from './services/dashboard-page-builder.service';
import { DashboardSeriesService } from './services/dashboard-series.service';
import { BaseSeriesService } from './services/base-series.service';
import { ChartSetupSearchService } from './services/chart-setup-search.service';
import { FixedChartSourceDataService } from './services/fixed-chart-source-data.service';
import { EventsService } from '../../Core/Users/services/events.service';

import { ChartSettingsDialogComponent } from './components/ChartSettingsDialog/chart-settings-dialog.component';
import { SharedGridsterLayoutComponent } from './components/SharedGridsterLayout/shared-gridster-layout.component';
import { DashboardChartBlockComponent } from './components/DashboardChartBlock/dashboard-chart-block.component';
// eslint-disable-next-line max-len
import { DashboardCoverageSummaryChartBlockComponent } from './components/DashboardCoverageSummaryChartBlock/dashboard-coverage-summary-chart-block.component';
import { DashboardTopTermChartBlockComponent } from './components/DashboardTopTermChartBlock/dashboard-top-term-chart-block.component';
import { DashboardTopPostsChartBlockComponent } from './components/DashboardTopPostsChartBlock/dashboard-top-posts-chart-block.component';
import { DashboardTopMentionsChartBlockComponent } from './components/DashboardTopMentionsChartBlock/dashboard-top-mentions-chart-block.component';

const DECLARATION_COMPONENTS = [
    SharedGridsterLayoutComponent,
    ChartSettingsDialogComponent,
    DashboardChartBlockComponent,
    DashboardCoverageSummaryChartBlockComponent,
    DashboardTopTermChartBlockComponent,
    DashboardTopPostsChartBlockComponent,
    DashboardTopMentionsChartBlockComponent
];

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        Gridster,
        GridsterItem,
        ClickOutsideModule,
        CommonFormsModule,
        LocalizationModule,
        LayoutModule,
        FormsModule,
        MiscModule,
        CommonBasicModule,
        PageBuilderModule,
        ReportsModule,
        CommonBasicModule,
        FilterModule,
        TooltipModule,
        RouterModule,
        ChartsModule,
        CommonDialogsModule,
        TakeOverModule,
        MonitorSharedModule
    ],
    declarations: [
        ...DECLARATION_COMPONENTS
    ],
    exports: [
        ...DECLARATION_COMPONENTS
    ],
    providers: [
        DashboardApi,
        ChartSetupSearchService,
        DashboardService,
        DashboardPageBuilderService,
        DashboardSeriesService,
        BaseSeriesService,
        FixedChartSourceDataService,
        EventsService
    ]
})
export class DashboardSharedModule { }
